import "./TotalCarbonImpactKPI.css";

import { useMemo } from "react";

import { ComponentProperties } from "../../../../route/shared/projects/project/overview/components/StandardSpecificSection/types";
import { thousandsFormatter } from "../../../../utils";
import { GenericTooltip } from "../../../forms";

interface TotalSequestrationProps {
  carbonImpactType: ComponentProperties | undefined;
  carbonImpactValue: number;
}

const getProjectSize = (totalSequestration: number): string => {
  if (totalSequestration > 10000) return "Large";
  if (totalSequestration > 2500) return "Medium";
  if (totalSequestration >= 0) return "Small";
  return "";
};

export const TotalCarbonImpactKPI = ({ carbonImpactType, carbonImpactValue }: TotalSequestrationProps): JSX.Element => {
  const steps = useMemo(
    () => [
      {
        tooltipText: "Large",
      },
      {
        tooltipText: "Medium",
      },
      {
        tooltipText: "Small",
      },
    ],
    []
  );

  const totalCarbonImpactValueFormatted = thousandsFormatter.format(carbonImpactValue).toLowerCase();

  return (
    <div className="TotalSequestrationContainer">
      <div className={`TotalSequestrationGraph ${getProjectSize(carbonImpactValue)}`}>
        {steps.map((step) => {
          return (
            <GenericTooltip
              key={step.tooltipText}
              placement="bottomLeft"
              content={
                <div className="TotalSequestrationTooltipContainer">
                  <p className="body3">{step.tooltipText}</p>
                </div>
              }
            >
              <div className={`GraphSection ${step.tooltipText}`} />
            </GenericTooltip>
          );
        })}
      </div>
      <div className="TotalSequestrationHeaderArea">
        {carbonImpactValue !== undefined && carbonImpactValue !== null && carbonImpactType ? (
          <h2>
            {totalCarbonImpactValueFormatted} {carbonImpactType.suffix}
          </h2>
        ) : (
          <h2>N/A</h2>
        )}
        {carbonImpactType && <p className="body2">{carbonImpactType.label}</p>}
        {carbonImpactValue && <p className="body3">{getProjectSize(carbonImpactValue)} size project</p>}
      </div>
    </div>
  );
};
